import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Col, Grid, Row} from 'react-bootstrap';
import PageTitle from '../../common/page-title/index';
import {getLevels} from '../../../actions/levels';
import LevelList from './level-list';
import Button from '../../common/button';

class Levels extends Component {
  componentWillMount() {
    this.props.dispatch(getLevels());
  }

  render() {
    const {levels, fetched, fetching} = this.props;
    return (
      <Grid bsClass="container" fluid className="levels">
        <Row>
          <Col lg={12}>
            <PageTitle>
              Levels
            </PageTitle>
          </Col>
        </Row>
        <Row className="mg-bottom-20">
          <Col lg={12}>
            <Link className="pull-left" to="/admin/levels/new">
              <Button
                className="add-level"
                color="red"
                permissions={{
                  action: 'add',
                  subjectClass: 'Level'
                }}
              >
                Add level
              </Button>
            </Link>
            <Link className="pull-right" to="/admin/update-level">
              <Button
                className="update-level"
                color="red"
                permissions={{
                  action: 'read',
                  subjectClass: 'Level'
                }}
              >
                Level updates
              </Button>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <LevelList
              fetched={fetched}
              fetching={fetching}
              levels={levels}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  levels: state.level.levels,
  fetched: state.level.fetched,
  fetching: state.level.fetching,
});

export default connect(mapStateToProps)(Levels);



// WEBPACK FOOTER //
// ./src/components/admin/levels/levels.jsx